import { CHAT_API_ENDPOINTS } from "../api/CHAT_API_ENDPOINTS";

// Single source of truth for which backend the admin dashboard talks to. The
// dashboard is product-scoped: everything (metrics, feedback, dev toggle, admin
// check, chat history) reads from the backend of the product the admin came
// from — PNC vs Shop Manual.

const isDev = process.env.NODE_ENV === "development";

const PNC_ADMIN_BASE = isDev
  ? "http://localhost:5000/v1/admin"
  : "/v1/admin";

// Sits under the Shop Manual API prefix so the gateway routes it to that service.
const SHOP_MANUAL_ADMIN_BASE = isDev
  ? "http://localhost:5000/api/v1/shop-manual/admin"
  : "/api/v1/shop-manual/admin";

export const ADMIN_CONTEXTS = { PNC: "pnc", SHOP_MANUAL: "shopmanual" };

const ADMIN_API = {
  [ADMIN_CONTEXTS.PNC]: {
    label: "Part Search",
    chatRoute: "/pnc",
    base: PNC_ADMIN_BASE,
    titleListUrl: CHAT_API_ENDPOINTS.GET_CHAT_HISTORY_LIST,
    chatHistoryUrl: CHAT_API_ENDPOINTS.GET_CHAT_HISTORY_DETAILS,
  },
  [ADMIN_CONTEXTS.SHOP_MANUAL]: {
    label: "Shop Manual",
    chatRoute: "/shop-manual",
    base: SHOP_MANUAL_ADMIN_BASE,
    titleListUrl: CHAT_API_ENDPOINTS.SHOP_MANUAL_GET_CHAT_HISTORY_LIST,
    chatHistoryUrl: CHAT_API_ENDPOINTS.SHOP_MANUAL_GET_CHAT_HISTORY_DETAILS,
  },
};

/** Resolve a context to its config, falling back to PNC for anything unknown. */
export function getAdminConfig(context) {
  return ADMIN_API[context] || ADMIN_API[ADMIN_CONTEXTS.PNC];
}

export const dashboardUrl   = (ctx) => `${getAdminConfig(ctx).base}/dashboard`;
export const checkUrl       = (ctx) => `${getAdminConfig(ctx).base}/check`;
export const usersUrl       = (ctx) => `${getAdminConfig(ctx).base}/users`;
export const feedbackUrl    = (ctx) => `${getAdminConfig(ctx).base}/feedback`;
export const devPatchUrl    = (ctx, userId) => `${getAdminConfig(ctx).base}/users/${userId}/dev`;
export const adminPatchUrl  = (ctx, userId) => `${getAdminConfig(ctx).base}/users/${userId}/admin`;
export const titleListUrl   = (ctx) => getAdminConfig(ctx).titleListUrl;
export const chatHistoryUrl = (ctx) => getAdminConfig(ctx).chatHistoryUrl;
export const productLabel   = (ctx) => getAdminConfig(ctx).label;
export const chatRoute      = (ctx) => getAdminConfig(ctx).chatRoute;
